<script setup lang="ts">
definePage({
  meta: {
    layout: 'public',
    requiresAuth: false,
  },
})
</script>

<template>
  <section class="flex flex-col items-center space-y-4">
    <RouterLink
      to="/new-user/existing-customer"
      class="mt-1 block font-medium text-gray-900 hover:underline"
    >
      <Button color="blue">{{ $t('newUser.existingCustomer.title') }}</Button>
    </RouterLink>
    <RouterLink
      to="/new-user/new-customer"
      class="mt-1 block font-medium text-gray-900 hover:underline"
    >
      <Button color="blue">{{ $t('newUser.newCustomer.title') }}</Button>
    </RouterLink>
  </section>
</template>
